import { LeaderboardService } from "shared/services/leaderboard.service";
import { PreloaderHelper } from "shared/helpers";
import { SignUpService } from "./signup.service";
import config from "config";
import { UserService } from "./users.service";
import { MainMenuService } from "./mainMenu.service";
export class SignInService {
    private signInScreen;
    private signUpService: SignUpService;
    private mainMenuService: MainMenuService;

    public show(): void {
        this.signInScreen = document.getElementById('signIn');
        this.signInScreen.style.visibility = 'visible';

        this.signUpService = new SignUpService();

        this.addListeners();
    }

    private validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    private async addListeners(): Promise<void> {
        const signUpBtn = document.getElementById('signUp_link_btn') as HTMLButtonElement;
        signUpBtn.addEventListener('click', () => {
            this.signInScreen.style.visibility = 'hidden';

            this.signUpService.show();
        })
        const email = document.getElementById('email_in') as HTMLInputElement;

        const eventEmail = (e) => {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const check = this.validateEmail(e.target.value);
            const error = document.getElementById('email-errors_in') as HTMLElement;
            if(value){
                email.classList.remove('form__input--empty');
                //@ts-ignore
                if(check) error.children[0].style.display = 'none';
                //@ts-ignore
                else error.children[0].style.display = 'block';             
            } else {
                email.classList.add('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'block';
            }
        }

        email.addEventListener('input', (e: any) => eventEmail(e));
        email.addEventListener('focus', (e: any) => eventEmail(e));
   
        const eventPass = (e) => {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const error = document.getElementById('password-errors-in') as HTMLElement;
            if(value){
                password.classList.remove('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'none';
            } else {
                password.classList.add('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'block';
            }
        }

        const password = document.getElementById('password_in') as HTMLInputElement;
        password.addEventListener('input', (e: any) => eventPass(e));
        password.addEventListener('focus', (e: any) => eventPass(e));

        const btnPass = document.getElementById('toggle_pass_in');
        btnPass.addEventListener('click', () => {
            const typePass = password.getAttribute('type');
            if(typePass === 'password') password.setAttribute('type', 'text');
            else password.setAttribute('type', 'password');
        });

        const btn = document.getElementById('signin_btn');
        const data = {
            email: "anaa_mny_game_2@cc.com",
            password: "7147aNa!",
            urlReferrer: "/match-the-ink-game"
        }
        btn.addEventListener('click', async (e: MouseEvent) => {
            e.preventDefault();

            const token = await this.loadCaptcha();
            console.log('token ::', token);
            
            const check = this.checkForm();


            const data = JSON.stringify({
                username: email.value,
                password: password.value,
                recaptchaToken: token,
                redirectUrl: '/match-the-ink-game'
            });
            const requestOptions = {
                method: 'POST',
                redirect: 'follow',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: data
            };
            if (check) {
                if(config.debugMode) {
                    const testData = {
                        id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                        token: "/ZLTG2qVzUCmVRUTNLNa9Q==",
                        message: "",
                        status: "200",
                        redirectUrl: "/match-the-ink-game"
                    }

                    config.token = testData.token;
                    config.playerId = testData.id;
                    this.moveMaineMenu();
                } else {                    
                    //@ts-ignore
                    await fetch(`${config.path}/match-game/login`, requestOptions)
                    // await fetch(`${config.path}/match-game/login?username=${email.value}&password=${password.value}&redirectUrl=/match-the-ink-game`, requestOptions)
                        .then(response => response.json())
                        .then((result: any) => {
                            // console.log(result);
                            const error = document.getElementById('login_error') as HTMLElement;
                            if(result.message === "recaptcha-mandatory") {
                                error.style.display = 'block';
                                error.textContent = 'recaptcha wrong';
                            } else if(result.status === '410' || result.id === null) {
                                error.style.display = 'block';
                                error.textContent = 'Invalid Email/Password';
                            } else {
                                config.token = result.token;
                                config.playerId = result.id;

                                error.style.display = 'none';

                                sessionStorage.setItem('token', JSON.stringify({
                                    token: result.token,
                                    id: result.id
                                }));
                                this.moveMaineMenu();
                            }
                        })
                        .catch(error => {
                            console.log('error', error);
                        });
                }
                
            }
        })
    }

    private async moveMaineMenu() {
        this.mainMenuService = new MainMenuService();
        config.guest = false;
        await UserService.getUserData();
        this.signInScreen.style.visibility = 'hidden';

        if(config.nickname) {
            this.mainMenuService.show(config.nickname);
        } else {
            const login = document.getElementById('login');
            login.style.visibility = 'visible';
        }
    }

    private checkForm() {
        let valid = true;
        const email = document.getElementById('email_in') as HTMLInputElement;
        const check = this.validateEmail(email.value);
        const value = email.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const error = document.getElementById('email-errors_in') as HTMLElement;
        valid = check && valid;
        if(value){
            email.classList.remove('form__input--empty');
            //@ts-ignore
            if(check) error.children[0].style.display = 'none';
        } else {
            email.classList.add('form__input--empty');
            //@ts-ignore
            error.children[0].style.display = 'block';
        }

        const password = document.getElementById('password_in') as HTMLInputElement;
        const valPass = password.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const errorPass = document.getElementById('password-errors-in') as HTMLElement;
        valid = !!valPass && valid;
        // debugger
        if(valPass){
            password.classList.remove('form__input--empty');
            //@ts-ignore
            errorPass.children[0].style.display = 'none';
        } else {
            password.classList.add('form__input--empty');
            //@ts-ignore
            errorPass.children[0].style.display = 'block';
        }

        // //@ts-ignore
        // grecaptcha.ready(function() {
        //     //@ts-ignore
        //     grecaptcha.execute('6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7', {action: 'submit'}).then(function(token) {
        //         // console.log('token ::', token);                
        //         // Add your logic to submit to your backend server here.
        //     });
        // });

        return valid;
    }


    private async loadCaptcha() {
        const head = document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://www.google.com/recaptcha/api.js?render=6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7';
		head.appendChild(script);

        const token = await new Promise( resolve => {
            script.onload = async() => {
                //@ts-ignore
                grecaptcha.ready(function() {
                    //@ts-ignore
                    grecaptcha.execute('6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7', {action: 'submit'}).then(function(token) {
                        // console.log('token ::', token);
                        resolve(token);            
                        // Add your logic to submit to your backend server here.
                    });
                });
            }
        }) 
        
        return token;
    }
}

//https://cms-qa-mny-us.maybelline.com/match-game/login?username=anaa_mny_game_2@cc.com&password=7147aNa!&redirectUrl=/match-the-ink-game  test link postman 